<template>
  <div>
    <div v-if="guardians && guardians.length > 0">
        <v-card class="my-2" v-for="guardian in guardians" :key="guardian.id">
        <v-card-title>
            {{ guardian.fullName }}
        </v-card-title>
        <v-card-subtitle>
            <span>{{ guardian.email }}</span>
            <v-divider vertical class="mx-2" />
            <span class="font-weight-light">
                <the-mask :value="guardian.phone" :mask="['(###) ###-####']" />
            </span>
        </v-card-subtitle>
        </v-card>
    </div>
    <v-sheet v-else class="pa-3 text-subtitle2 text-center font-weight-light">
        No guardians info found
    </v-sheet>
  </div>
</template>

<script>
import { TheMask } from "vue-the-mask";
export default {
  props: {
    student: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    guardians: [],
  }),
  mounted() {
    this.fetchGuardians();
  },
  components: { TheMask },
  methods: {
    fetchGuardians() {
      this.$axios
        .get("/rp/get-guardians/" + this.student.contactId)
        .then((resp) => {
          this.guardians = resp.data;
        });
    },
  },
};
</script>

<style>
</style>